import React, { createContext, useContext } from 'react';
import { Trial } from '../models/Trial';

interface TableContext {
  trials: Trial[];
  trialsCategories: string[];
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

export const tableContext = createContext<TableContext>({
  trials: [],
  trialsCategories: [],
  currentPage: 1,
  setCurrentPage: () => {},
});

export const TableProvider = tableContext.Provider;

export const useTableContext = () => useContext(tableContext);
